import Component from '@glimmer/component';
import Chip from 'tio-ui/components/chip';
import { t } from 'ember-intl';
import type { ChipIntent } from 'tio-ui/components/chip';

interface S {
  Args: {
    /** Clause names from OpenSearch `matched_queries` (e.g. ['payroll', 'name_exact']). */
    matches?: string[];
  };
  Element: HTMLSpanElement;
}

interface Reason {
  labelKey: string;
  intent: ChipIntent;
}

/**
 * Renders "why this matched" chips from a hit's `matchedQueries`.
 *
 * Name has two flavors: `name_exact` (every search token present in the name —
 * shown as a distinct success chip) and `name` (partial / single-token match).
 * When both are present the exact flag wins; other fields render as plain
 * "Matched: …" chips.
 */
export default class MatchReason extends Component<S> {
  get reasons(): Reason[] {
    const set = new Set(this.args.matches ?? []);
    const reasons: Reason[] = [];

    if (set.has('name_exact')) {
      reasons.push({ labelKey: 'people.matched.name_exact', intent: 'success' });
    } else if (set.has('name')) {
      reasons.push({ labelKey: 'people.matched.name', intent: 'primary' });
    }
    if (set.has('email')) reasons.push({ labelKey: 'people.matched.email', intent: 'primary' });
    if (set.has('payroll')) reasons.push({ labelKey: 'people.matched.payroll', intent: 'primary' });
    if (set.has('employee_id')) {
      reasons.push({ labelKey: 'people.matched.employee_id', intent: 'primary' });
    }

    return reasons;
  }

  <template>
    {{#if this.reasons.length}}
      <span class="tio-cluster" ...attributes>
        {{#each this.reasons as |reason|}}
          <Chip @intent={{reason.intent}} @appearance="faded" @size="sm">
            {{t reason.labelKey}}
          </Chip>
        {{/each}}
      </span>
    {{/if}}
  </template>
}
